import { defineAsyncComponent } from 'vue'
export default {
  atlas: defineAsyncComponent(() => import("/builds/the-eastern-polygon/web/layouts/atlas.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/the-eastern-polygon/web/layouts/default.vue").then(m => m.default || m))
}